import React from "react";
import PropTypes from "prop-types";

import Search from "../../general/Search";
import Select from "../Select";
import Statuses from "../../group-lessons/Statuses";

const Header = ({
  isAdmin,
  locations,
  location,
  status,
  onChangeLocation,
  onSearch,
  onChangeStatus,
  onAdd,
  onExport
}) => (
  <div className="row">
    <div className="col-md-3 col-xs-12">
      <Select
        selectTitle={"select location"}
        options={locations}
        value={location}
        onChange={onChangeLocation}
      />
    </div>
    <Statuses 
        statusTitle={"select status"}
        selectClassName="col-md-2 col-xs-12"
        value={status}
        onChange={onChangeStatus} />
    <Search
      fieldClassName="col-md-3 col-xs-12"
      placeholder="Search..."
      newSearchCallback={onSearch}
    />

    {isAdmin ? (
      <div className="col-xs-3 col-sm-3 col-md-4 pull-right">
        <div className="pull-right">
          <button
            className="btn btn-pink btn-raised btn-long margin-right-five"
            onClick={onAdd}
          >
            ADD
          </button>
          <button
            className="btn btn-indigo btn-raised btn-long margin-right-five"
            onClick={onExport}
          >
            EXPORT
          </button>
          <br className="visible-xs visible-sm"/>
          <br className="visible-xs visible-sm"/>
        </div>
      </div>
    ) : null}
  </div>
);

Header.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  locations: PropTypes.array.isRequired,
  location: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  onChangeLocation: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onChangeStatus: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired
};

export default Header;
